import { useStore } from "@nanostores/react";
import { useRef } from "react";
import { ClaimFailedModal } from "../components/bridge/ClaimFailedModal";
import { ClaimSuccessModal } from "../components/bridge/ClaimSuccessModal";
import { ClaimWaitingModal } from "../components/bridge/ClaimWaitingModal";
import { TxHistoryTable } from "../components/tx_history/TxHistoryTable";
import { useBridgeClaimMutation } from "../mutations/bridge";
import { $bridgeTxHistoryAtom } from "../state/bridgeTxHistory";
import type {
  BridgeClaimParams,
  BridgeTxClaimedFailed,
  BridgeTxClaimedSuccess,
  BridgeTxUnclaimedSuccess,
} from "../state/types";

export default function TransactionsRoute() {
  const bridgeTxHistory = useStore($bridgeTxHistoryAtom);
  // Used for Waiting modal
  const unclaimedSuccessTxDataRef = useRef<BridgeTxUnclaimedSuccess | null>(null);
  // Claim Tx result
  const claimedSuccessTxDataRef = useRef<BridgeTxClaimedSuccess | null>(null);
  const claimedFailedTxDataRef = useRef<BridgeTxClaimedFailed | null>(null);

  const bridgeClaimMutation = useBridgeClaimMutation({
    onSuccess: (claimedTxData) => {
      claimedSuccessTxDataRef.current = claimedTxData;
      claimedFailedTxDataRef.current = null;
    },
    onError: (failedTxData) => {
      claimedFailedTxDataRef.current = failedTxData;
      claimedSuccessTxDataRef.current = null;
    },
  });

  return (
    <div className="max-w-screen-xl mx-auto my-8 p-4">
      <h1 className="font-['Krona_One'] text-4xl mb-8">Transaction History</h1>

      <TxHistoryTable
        claimMutationStatus={bridgeClaimMutation.status}
        onClaim={(claimParams: BridgeClaimParams) => {
          // Find the corresponding unclaimed transaction from the history
          const unclaimedTx = bridgeTxHistory.find((tx) => tx.id === claimParams.id && tx.state === "unclaimed");
          if (unclaimedTx) {
            unclaimedSuccessTxDataRef.current = unclaimedTx as BridgeTxUnclaimedSuccess;
          }
          bridgeClaimMutation.mutate(claimParams);
        }}
      />

      <ClaimWaitingModal
        isOpen={bridgeClaimMutation.status === "pending"}
        unclaimedTxData={unclaimedSuccessTxDataRef.current}
      />

      <ClaimSuccessModal
        isOpen={bridgeClaimMutation.status === "success"}
        onClose={() => bridgeClaimMutation.reset()}
        claimedTxData={claimedSuccessTxDataRef.current}
      />

      <ClaimFailedModal
        isOpen={bridgeClaimMutation.status === "error"}
        onClose={() => bridgeClaimMutation.reset()}
        failedTxData={claimedFailedTxDataRef.current}
      />
    </div>
  );
}
